import React, { useState } from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import Section from '../Section';
import DepartmentSectionStyle2 from '../Section/DepartmentSection/DepartmentSectionStyle2';
import FeaturesSectionStyle2 from '../Section/FeaturesSection/FeaturesSectionStyle2';
import FunFactSection from '../Section/FunFactSection';
import TeamSection from '../Section/TeamSection';
import GallerySection from '../Section/GallerySection';
import AwardSectionStyle2 from '../Section/AwardSection/AwardSectionStyle2';
import { pageTitle } from '../../helpers/PageTitle';
import { getLandingPageBySlug } from '../../service/api';
import { useEffect } from 'react';
import { previewAssetUrl } from '../../helpers';

const awardData = [
  {
    iconUrl: '/images/icons/award.svg',
    title: 'Malcolm Baldrige National Quality Award',
  },
  { iconUrl: '/images/icons/award.svg', title: 'HIMSS Davies Award' },
  {
    iconUrl: '/images/icons/award.svg',
    title: 'Healthgrades National’s Best Hospital',
  },
  {
    iconUrl: '/images/icons/award.svg',
    title: 'Joint Commission Gold Seal of Approval',
  },
];

export default function About() {
  const [data, setData] = useState(null);
  const content = data?.content || {};

  const fetchData = async () => {
    try {
      const data = await getLandingPageBySlug('about');
      setData(data);
    } catch (error) {
      console.error('Error fetching landing page:', error);
    }
  };

  pageTitle('Về chúng tôi');

  console.log('content', content);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <BannerSectionStyle3
        bgUrl='/images/about/banner_bg.svg'
        imgUrl={
          content?.introduction?.bannerId
            ? previewAssetUrl(content?.introduction?.bannerId)
            : 'images/about/banner_img.png'
        }
        title={content?.introduction?.title || ''}
        subTitle={content?.introduction?.content || ''}
      />
      <Section topMd={200} topLg={150} topXl={110}>
        <DepartmentSectionStyle2
          sectionTitle='Cung cấp dịch vụ tốt nhất của chúng tôi'
          sectionTitleUp='DỊCH VỤ'
          data={content?.services?.map((service) => ({
            title: service?.title,
            subTitle: service?.content,
            iconUrl: previewAssetUrl(service?.iconId),
          }))}
        />
      </Section>
      <Section topMd={175} topLg={125} topXl={85} bottomMd={100} bottomLg={110}>
        <FeaturesSectionStyle2
          sectionTitle='Tại sao chọn chúng tôi'
          imgUrl={
            content?.whyChooseUsMain?.bannerId
              ? previewAssetUrl(content?.whyChooseUsMain?.bannerId)
              : 'images/about/features_img.png'
          }
          data={content?.whyChooseUs?.map((item) => ({
            title: item?.title,
            subTitle: item?.content,
            iconUrl: previewAssetUrl(item?.iconId),
          }))}
        />
      </Section>
      <Section>
        <FunFactSection
          bgUrl='images/about/fun_fact_bg.jpeg'
          data={content?.statistics?.map((item) => ({
            number: item?.title,
            title: item?.content,
          }))}
        />
      </Section>
      <Section topMd={190} topLg={145} topXl={105}>
        <TeamSection
          sectionTitle='Bác sĩ chuyên môn'
          sectionTitleUp='GẶP GỠ CỦA CHÚNG TÔI'
          data={content?.doctors?.map((member) => ({
            imgUrl: previewAssetUrl(member?.avatarId),
            name: member?.title,
            designation: member?.role,
            description: member?.content,
          }))}
        />
      </Section>
      <Section topMd={170} topLg={120} topXl={80}>
        <GallerySection
          sectionTitle={content?.activity?.content || ''}
          sectionTitleUp={content?.activity?.title || ''}
          data={[
            content?.activity?.portfolioImageId1,
            content?.activity?.portfolioImageId2,
            content?.activity?.portfolioImageId3,
            content?.activity?.portfolioImageId4,
            content?.activity?.portfolioImageId5,
          ].map((id) => ({
            imgUrl: previewAssetUrl(id),
          }))}
        />
      </Section>
      {/* <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <AwardSectionStyle2
          sectionTitle='Winning Awards and <br />Recognition'
          sectionTitleUp='AWARDS'
          sectionSubTitle='We have been recognized for our commitment to <br />excellence in healthcare.'
          data={awardData}
        />
      </Section> */}
      <Section
        className='cs_footer_margin_0'
        topMd={190}
        topLg={145}
        topXl={105}
      >
        <BannerSectionStyle4
          bgUrl={
            content?.subBanner?.bannerId
              ? previewAssetUrl(content?.subBanner?.bannerId)
              : 'images/banner/banner_bg_4.jpeg'
          }
          title={content?.subBanner?.title || ''}
          subTitle={content?.subBanner?.content || ''}
          center
        />
      </Section>
    </>
  );
}
